import React from 'react'
import { Button, Tag, Tooltip, Progress, Input, Space } from 'antd'
import { EditOutlined, SearchOutlined } from '@ant-design/icons'
import moment from 'moment'
import { StatusTag, ActionButtons } from './ArcCampaigns.styles'

export const getColumns = ({ onEdit, includedData }) => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    sorter: true,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 250,
    sorter: true,
    render: (name) => (
      <Tooltip title={name}>
        <span style={{ fontWeight: 500 }}>{name}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Brand Name',
    dataIndex: 'brand_name',
    key: 'brand_name',
    width: 150,
    sorter: true,
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search brand name"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters()
              confirm()
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record.brand_name
        ? record.brand_name.toString().toLowerCase().includes(value.toLowerCase())
        : false,
    render: (brandName) => brandName || '-',
  },
  {
    title: 'Offer',
    dataIndex: 'offer',
    key: 'offer',
    width: 180,
    render: (offer) => offer || '-',
  },
  {
    title: 'Source',
    dataIndex: 'source',
    key: 'source',
    width: 100,
    filters: [
      { text: 'Karma', value: 'karma' },
      { text: 'Imageye', value: 'imageye' },
    ],
    render: (source) => (
      <Tag color={source === 'karma' ? 'blue' : 'purple'}>
        {source?.toUpperCase()}
      </Tag>
    ),
  },
  {
    title: 'Impressions',
    key: 'impressions',
    width: 120,
    render: (_, record) => {
      const cap = record.impression_cap
      const count = record.impression_count || 0

      if(!cap && !count) return '-'

      if (!cap) return `${count.toLocaleString()} / -`

      const percentage = Math.min((count / cap) * 100, 100)

      return (
        <div style={{ minWidth: 120 }}>
          <div style={{ fontSize: '12px', marginBottom: 4 }}>
            {count.toLocaleString()} / {cap.toLocaleString()}
          </div>
          <Progress
            percent={percentage}
            size="small"
            strokeColor={percentage >= 90 ? '#ff4d4f' : '#1890ff'}
            showInfo={false}
          />
        </div>
      )
    },
  },
  {
    title: 'Clicks',
    key: 'clicks',
    width: 120,
    render: (_, record) => {
      const cap = record.click_cap
      const count = record.click_count || 0

      if(!cap && !count) return '-'
      if (!cap) return `${count.toLocaleString()} / -`

      const percentage = Math.min((count / cap) * 100, 100)

      return (
        <div style={{ minWidth: 120 }}>
          <div style={{ fontSize: '12px', marginBottom: 4 }}>
            {count.toLocaleString()} / {cap.toLocaleString()}
          </div>
          <Progress
            percent={percentage}
            size="small"
            strokeColor={percentage >= 90 ? '#ff4d4f' : '#1890ff'}
            showInfo={false}
          />
        </div>
      )
    },
  },
  {
    title: 'Start Date',
    dataIndex: 'started_at',
    key: 'started_at',
    width: 120,
    sorter: true,
    render: (date) => date ? moment(date).format('YYYY-MM-DD HH:mm') : '-',
  },
  {
    title: 'End Date',
    dataIndex: 'end_at',
    key: 'end_at',
    width: 120,
    sorter: true,
    render: (date) => date ? moment(date).format('YYYY-MM-DD HH:mm') : '-',
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 100,
    fixed: 'right',
    render: (_, record) => (
      <ActionButtons>
        <Tooltip title="Edit Campaign">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          />
        </Tooltip>
      </ActionButtons>
    ),
  },
]